import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoLocationMapPin = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>LocationMapPin</title>
    <path
      d="M24.553 18.857a10.237 10.237 0 0 0 1.732-5.715c0-5.68-4.605-10.285-10.285-10.285-5.681 0-10.286 4.605-10.286 10.285 0 2.115.638 4.08 1.732 5.715h-.018l.271.361.134.179 6.795 9.06a1.714 1.714 0 0 0 2.743 0l6.795-9.06.134-.179.271-.361h-.018Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <circle cx={15.998} cy={13.142} r={4.571} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default SvgIcoLocationMapPin;
